import { Component, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { BaseComponentComponent } from "app/pages/base/base-component/base-component.component";
import { TranslateService } from "@ngx-translate/core";
import { PublicService } from "app/services/public.service";
import { Dialogs } from "app/common/dialogs";
import { NgForm } from "@angular/forms";
import swal from 'sweetalert2';
import { Subscription } from "rxjs";


@Component({
  selector: ".content_inner_wrapper",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})

export class LoginComponent extends BaseComponentComponent implements OnDestroy {


  private subscription: Subscription;
  public loading: boolean = false;
  public emailRecover: string;
  public toggleRegister: boolean = false;

  constructor(public translate: TranslateService, private publicService: PublicService, private router: Router, private dialogs: Dialogs) {
    super();
  }

  onSubmit(form: NgForm) {
    this.setLoading(true);
    const email = form.value.username;
    const password = form.value.password;
    this.subscription = this.publicService.login(email, password)
      .subscribe(
      data => {
        // console.log("data.isExtrasAvailable",data.isExtrasAvailable.toString());
        this.setLoading(false);
        this.publicService.setAccessToken(data.accessToken);
        this.publicService.setName(data.fullName);
        this.publicService.setEMail(data.eMail);
        this.publicService.setClaim(data.claimId);
        this.publicService.setAvatarHash(data.avatarHash);
        this.publicService.setIsContractActive(data.isContractActive.toString());
        this.publicService.setIsExtrasAvaiable(data.isExtrasAvailable.toString());
        //console.log(data);
        //console.log(data.isContractActive);
        //console.log(data.idUser);
        
        this.publicService.setCurrnetUserId(data.idUser);

        if (this.publicService.isSuperAdmin()) {
          this.router.navigate(['/', 'projects']);
        } else {
          this.router.navigate(['/']);
        }
      },
      error => {
        // console.log(error);

        this.setLoading(false);
        if (error.statusText != "OK") {
          this.dialogs.showError(super.getMsgDialogs("_login_error"), error.statusText);
        } else {
          this.dialogs.showError(super.getMsgDialogs("_login_error"), "");
        }
      }
      );
  }

  private setLoading(loading: boolean): void {
    this.loading = loading;
  }

  public isEmptyText() {
    return this.emailRecover == "" ? true : false;
  }

  public onStartRecoveryPassword() {
    const sub = this.publicService.StartResotrePassword(this.emailRecover)
      .subscribe(
      data => {
        // console.log(data);
        this.dialogs.showItemUploaded("Email enviat", this.getString("CHECK_EMAIL"), "", false).then(
          function () {
            document.getElementById("btnModal").click();
          }, function (dissmis) { }
        )
      },
      error => {
        if (error.statusText=="Unknown Error") {
          this.dialogs.showItemUploaded("E-mail enviat!", "");
        } else {
          this.dialogs.showError("Error en enviar el email", error.statusText);
        }
      },
      () => { }
      );

    if (this.subscription != undefined) {
      this.subscription.add(sub);
    } else {
      this.subscription = sub;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription != undefined) {
      this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/public/login/login.component.ts